<div class="modal-overlay">
    <div class="iframe-container">
      <button class="close-btn" (click)="closeDialog()">×</button>
      <iframe
        [src]="sanitizedUrl"
        frameborder="0"
        width="90%"
        height="90%"
        
        allowfullscreen>
      </iframe>
    </div>
  </div>
  